import styled from "styled-components";
import { isWithBackground } from "./utils";
export const StyledTabTitle = styled.div `
  &&& {
    width: 100%;
    margin-top: 0 !important;
    text-transform: none !important;
    letter-spacing: normal !important;

    ${({ theme, stylingType }) => `font-weight: ${isWithBackground(stylingType)
    ? theme.fontWeights.regular
    : theme.fontWeights.medium} !important;`}

    ${({ theme }) => `font-size: ${theme.fontTokens.font12[0]} !important; line-height: ${theme.fontTokens.font11[1]} !important;`}
  
  ${({ stylingType }) => `margin-bottom: ${isWithBackground(stylingType) ? "0.125rem !important" : "0"};`};

    ${({ multiLine }) => multiLine ? "padding-top:9px;padding-bottom:9px;" : ""};

    @media ${({ theme }) => theme.device.touch} {
      ${({ multiLine }) => multiLine ? "padding-top:11px;padding-bottom:11px;" : ""};
    }
  }
`;
